// For dark themes add `isDarkTheme` key to theme object with value true

export const themes ={
    SB:{
    'materialIconsClr':'#0c3f64',
    'iconDark':'#0b284f',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#0c3f64',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#b8cbd9',
    'dropdownMenuHoverTxtClr':'#121b21',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#121b21',
    'uncheckedBg':'#fff',
    'checkedBg':'#6d94b0',
    'submitBtnBg':'#e7e7e8',
    'submitBtnClr':'#333',
    'submitBtnHvrBg':'#d0d0d2',
    'submitBtnHvrClr':'#333',
    'clearBtnBg':'#fff',
    'clearBtnClr':'#333',
    'clearBtnHvrBg':'#f9f9f9',
    'clearBtnHvrClr':'#333',
    'tooltipHoverBg':'rgba(101, 170, 203, 0.9)',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#1f4560',
    'actvOiClr':'#e6f4ff',
    'actvBtnBg':'#8baac1',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#dde6ec',
    'navBarSubClr':'#17384f',
    'repIconBg':"#b8cbd9 url('/images/reports-blck.png')",
    'homeIconBg':"#b8cbd9 url('/images/home-blck.png')",
    'addIconBg':"#b8cbd9 url('/images/add-blck.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#b8cbd9 url('/images/profile-blck.png')",
    'deliveryIconBg':"#b8cbd9 url('/images/delivery-blck.png')",
    'navMenuLabel':'#464e53',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#005999',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#5783a2',
    'calndrTileEnblHvrBg':'#7a9eb8',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#5783a2',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#b8cbd9',
    'widgetheaderclr':'#376181',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#b8cbd9',
    'headerFontClr':'#fff',
    'headerCaret':"#5985a6",
    'vericalDotIconClr':'#12202b',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#fff',
    'vericalDotIconHoverClr':'#12202b',
    'caret':'#5985a6',
    'closeBtnClr':'#12202b',
    'closeBtnBrd':'1px solid #12202b',
    'closeBtnHoverBg':'#f5f5f5',
    'closeBtnHoverClr':'#376181',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#dee7ed',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#7a9db8',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#acc2d2',
    //Notifications
    'notfictnVisiblebrdTop':'#8e9ca7',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#8e9ca7 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #8e9ca7',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#8e9ca7 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #8e9ca7',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#8e9ca7 1px 0px 1px 1px',
    'notfictnDismissClr':'rgb(11, 62, 99)',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#376181',
    'valDateClr':'#626c72',
    'defaultTabClr':'#0b3e63',
    'activeTabClr':'#051623',
    'activeTabBrd':'#476a85',
    'rateDiffBgClr':'#8baac1',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#a5acb4',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#e7e7e8',
    'sellBuyBtnFontClr':'#333',
    'caretIconClr':'#7a9db8',
    'ordConfirmMsgBg':'rgba(184, 203, 217, 095)',
    'ordConfirmMsgClr':'#0b3a5b',
    'closeOrdConfirmMsgIconBg':'rgba(184, 203, 217, 095)',
    'noRatesMsgDivBg':'rgba(184, 203, 217, 095)',
    'noRatesMsgDivClr':'#8fbcdc',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'trdBookDefaultTabClr':'#376181',
    'trdBookActTabClr':'#1f1f1f',
    'TrdBookActTbBrd':'#476a85',
    //Profile
    'prfWrpBg':'#fafafa',
    'prfWrpBrd':'#b6d7ea',
    'userMenuListBg':'#fafafa',
    'userMenuListClr':'#333',
    'userMenuActvBg':'#ebebeb',
    'userMenuActvClr':'#333',
    'userMenuHvrBg':'#d9d9d9',
    'hoverDivBg':'#c2ccd6',
    'versionNClr':'#5c666d',
    'changlogLblClr':'#3178a5',
    'changlogHeadingClr':'#02235d',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#b8cbd9',
    'tmpNameClr':'#376181',
    'tmpBtnBg':'#e7e7e8',
    'tmpBtnClr':'#333',
    //Chart
    'hamburgerIcon':'#0b284f',
    'timeheadBg':'#dfe3e6',
    'chartSideMenuBg':'#b8cbd9',
    'chartSideMenuClr':'#4c4c4c',
    'timeHeadLblClr':'rgb(49,120,165)',
    'timeHeadTextClr':'#003666',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#0a5287',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#2277a2',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'cardHeaderBg':'#b6d7ea',
    'addWidgetHeaderBg':'#b8cbd9',
    'addWidgetTitleClr':'#376181',
    'rptDefaultTabClr':'#0b3e63',
    'rtpTabBg':'#fff',
    'ModalBodyBg':'#fff',
    //Physical Delivery
    'placeRequestBtnBg': '#5D8AA1',
    'placeRequestBtnHover': '#51829A',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#51829A',
    },

    AQ:{
    'materialIconsClr':'#0c3f64',
    'iconDark':'#0b284f',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#0c3f64',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#4a93d3',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#4088ba',
    'uncheckedBg':'#fff',
    'checkedBg':'#3c8ac3',
    'submitBtnBg':'#3178a5',
    'submitBtnClr':'#fff',
    'submitBtnHvrBg':'#265c7e',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#c8e1f1',
    'clearBtnClr':'#132d44',
    'clearBtnHvrBg':'#89bcdc',
    'clearBtnHvrClr':'#143852',
    'tooltipHoverBg':'rgba(101, 170, 203, 0.9)',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#1f4560',
    'actvOiClr':'#e6f4ff',
    'actvBtnBg':'#1373c9',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#dde6ec',
    'navBarSubClr':'#17384f',
    'repIconBg':"#3b8ac3 url('/images/reports.png')",
    'homeIconBg':"#3b8ac3 url('/images/home.png')",
    'addIconBg':"#3b8ac3 url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#3b8ac3 url('/images/profile.png')",
    'deliveryIconBg':"#3b8ac3 url('/images/delivery.png')",
    'navMenuLabel':'#0069b5',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#337ab7',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#3c8ac3',
    'calndrTileEnblHvrBg':'#48a4ea',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#306fc5',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#3c8ac3',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#3c8ac3',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#fff',
    'vericalDotIconHoverClr':'#0b3e63',
    'caret':'#dfeef6',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#fff',
    'closeBtnHoverClr':'#0b3e63',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#b6d7ea',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#3c8ac3',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#99ccff',
    //Notifications
    'notfictnVisiblebrdTop':'rgb(60, 138, 195)',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'rgb(60, 138, 195) 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid rgb(60, 138, 195)',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'rgb(60, 138, 195) 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid rgb(60, 138, 195)',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'rgb(60, 138, 195) 1px 0px 1px 1px',
    'notfictnDismissClr':'rgb(11, 62, 99)',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#626c72',
    'defaultTabClr':'#0b3e63',
    'activeTabClr':'#306f9c',
    'activeTabBrd':'#306f9c',
    'rateDiffBgClr':'#b6d7ea',
    'rateDiffFontClr':'#224e6d',
    'tabContentBg':'#b6d7ea',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#65aacb',
    'sellBuyBtnFontClr':'#003147',
    'caretIconClr':'#0069a1',
    'ordConfirmMsgBg':'rgba(179,216,233,0.95)',
    'ordConfirmMsgClr':'#0b3a5b',
    'closeOrdConfirmMsgIconBg':'rgba(179,216,233,0.95)',
    'noRatesMsgDivBg':'rgba(13,82,141,0.83)',
    'noRatesMsgDivClr':'#8fbcdc',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'trdBookDefaultTabClr':'#d8e8f3',
    'trdBookActTabClr':'#fff',
    'TrdBookActTbBrd':'#0b3e63',
    //Profile
    'prfWrpBg':'#beebff',
    'prfWrpBrd':'#b0d2ff',
    'userMenuListBg':'#beebff',
    'userMenuListClr':'#1767a1',
    'userMenuActvBg':'#e6f7fe',
    'userMenuActvClr':'#1767a1',
    'userMenuHvrBg':'#afe2f8',
    'hoverDivBg':'#e6f7fe',
    'versionNClr':'#2c5572',
    'changlogLblClr':'#3178a5',
    'changlogHeadingClr':'#02235d',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#3c8ac3',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#b3d8ea',
    'tmpBtnClr':'#102433',
    //Chart
    'hamburgerIcon':'#0b284f',
    'timeheadBg':'#b6d7ea',
    'chartSideMenuBg':'#3c8ac3',
    'chartSideMenuClr':'#fff',
    'timeHeadLblClr':'rgb(49,120,165)',
    'timeHeadTextClr':'#0b284f',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#0a5287',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#2277a2',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'cardHeaderBg':'#b6d7ea',
    'addWidgetHeaderBg':'#3c8ac3',
    'addWidgetTitleClr':'#fff',
    'rptDefaultTabClr':'#0b3e63',
    'rtpTabBg':'#fff',
    'ModalBodyBg':'#fff',
    //Physical Delivery
    'placeRequestBtnBg': '#3178a5',
    'placeRequestBtnHover': '#265c7e',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#306f9c',
    },
    
    DR:{   
    'isDarkTheme': true,
    'materialIconsClr':'#b7b7b7',
    'iconDark':'#b7b7b7',
    'text-mutedClr':'#bfbfbf',
    'noDataColorBg':'#333',
    'mdlWrapBg':'#121212',
    'tabHeaderClr':'#fff',
    'countColor':'#b7b7b7',
    'errorTxtClr':'#cf6679',
    //Form Elements
    'inputBg':'#131112',
    'inputClr':'#ababab',
    'inputBorder':'#808080',
    'inputHvrFcsBorder':'#8c8c8c',
    'disableInputBg':'#333',
    'disableInputClr':'#999',
    'dropDownHoverBg':'#a9a9a9',
    'dropdownMenuHoverTxtClr':'#121b21',
    'dropdownMenuBgClr':'#2e2e2e',
    'dropdownMenuFontClr':'#c2c2c2',
    'uncheckedBg':'#131112',
    'checkedBg':'#4c4c4c',
    'submitBtnBg':'#444',
    'submitBtnClr':'#c9c9c9',
    'submitBtnHvrBg':'#333',
    'submitBtnHvrClr':'#c2c2c2',
    'clearBtnBg':'#ccc',
    'clearBtnClr':'#333',
    'clearBtnHvrBg':'#999',
    'clearBtnHvrClr':'#333',
    'tooltipHoverBg':'rgba(61, 61, 61, 0.8)',//'rgb(51 51 51 / 0.9)',
    'tooltipHoverClr':'rgb(204, 204, 204)',//'#f9f9f9',
    'oi-eyeClr':'#b7b7b7',
    'actvOiClr':'#e6f4ff',
    'actvBtnBg':'#5e5e64',
    //Table
    'tblBg':'#171717',
    'tblClr':'#c2c2c2',
    'thBg':'#222225',
    'thClr':'#c2c2c2',
    'tdBorder':'#404040',
    'listRowOddBg':'#141414',
    'listRowClr':'#000',
    'listRowBrdClr':'#2c2c30',
    'listRowNextBg':'#1c1c1c',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#2c2c30',
    'pagingPnlClr':'#c2c2c2',
    'tableBodyTxtClr':'#c2c2c2',
    // 'dx_g_bs4_table_cellClr':'#fff', 
    'dx_g_bs4_table_cellBrd':'#2c2c30',    
    //Navbar    
    'navBarBg':'#131112',
    'navBarSubBg':'#201d1f',
    'navBarSubClr':'#c2c2c2',
    'repIconBg':"#333 url('/images/reports.png')",
    'homeIconBg':"#333 url('/images/home.png')",
    'addIconBg':"#333 url('/images/add.png')",
    'addDisabledBg':"#2c2c30 url('/images/add-grey.png')",
    'prflIconBg':"#333 url('/images/profile.png')",
    'deliveryIconBg':"#333 url('/images/delivery.png')",
    'navMenuLabel':'#c2c2c2',
    'responsiveReactGridLayoutBg':'#262425',
    'react-grid-itemBg':'#121212',
    //Calendar
    'calendrHeading':'#d1d1d1',
    'calendrBg':'#1a1a1a',
    'calendrClr':'#c2c2c2',
    'calndrTileActBg':'#4d4d4d',
    'calndrTileEnblHvrBg':'#808080',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#808080',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender-light.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#313135',
    'widgetheaderclr':'#c2c2c2',
    'widgetBdyBg':'#121212',
    'widgetlabel':'#b0b3b5',
    'headerBgClr':'#b8cbd9',
    'headerFontClr':'#fff',
    'headerCaret':"#bdbdc5",
    'vericalDotIconClr':'#bdbdc5',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#d7d7d7',
    'vericalDotIconHoverClr':'#12202b',
    'caret':'#bdbdc5',
    'closeBtnClr':'#bdbdc5',
    'closeBtnBrd':'1px solid #bdbdc5',
    'closeBtnHoverBg':'#d7d7d7',
    'closeBtnHoverClr':'#333',
    'widgetwrapperBg':'#121212',
    'widgetwrapperBrd':'#121212',
    'subHeaderBg':'#1a1a1a',
    //ResizeGrid
    'resizeLyoutBg':'#363636',
    'resizeGridSelectBg':'#000',
    'resizeGridSelectBrd':'#a1a1aa',
    'resizeGridBoxHvrBg':'#5c5c5c',
    //Notifications
    'notfictnVisiblebrdTop':'#c1c1c1',
    'notfictnVisibleBg':'#3b3b3b',
    'notfictnVisibleClr':'#efefef',
    'notfictnVisibleBoxShdw':'#3b3b3b 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #c1c1c1',
    'notfictnSuccessBg':'#3b3b3b',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'none',
    'notificationBrdTop':'4px solid #c1c1c1',
    'notificationBg':'#3b3b3b',
    'notfictnClr':'#efefef',
    'notfictnBox-shadow':'#3b3b3b 1px 0px 1px 1px',
    'notfictnDismissClr':'#efefef',
    'notfictnDismissBg':'none',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#131112',
    'WidgetCmdtytitleClr':'#c2c2c2',
    'valDateClr':'#cacad1',
    'defaultTabClr':'#999',
    'activeTabClr':'#e0e0e0',
    'activeTabBrd':'#b7b7b7',
    'rateDiffBgClr':'#262626',
    'rateDiffFontClr':'#cacad1',
    'tabContentBg':'#313135',
    'ratesBg':'#131112',
    'sellBuyBtnBgClr':'#444',
    'sellBuyBtnFontClr':'#c9c9c9',
    'caretIconClr':'#bdbdc5',
    'ordConfirmMsgBg':'rgba(73,73,73,0.95)',
    'ordConfirmMsgClr':'#f7f7f7',
    'closeOrdConfirmMsgIconBg':'rgba(73,73,73,0.95)',
    'noRatesMsgDivBg':'rgba(73,73,73,0.95)',
    'noRatesMsgDivClr':'#f7f7f7',
    'pfoLblBg':'#121212',
    'pfoLblClr':'#c2c2c2',
    //Trade Book
    'trdBookDefaultTabClr':'#999',
    'trdBookActTabClr':'#d3d3d3',
    'TrdBookActTbBrd':'#a7a7a7',
    //Profile
    'prfWrpBg':'#242424',
    'prfWrpBrd':'#343434',
    'userMenuListBg':'#242424',
    'userMenuListClr':'#c2c2c2',
    'userMenuActvBg':'#424242',
    'userMenuActvClr':'#c2c2c2',
    'userMenuHvrBg':'#666',
    'hoverDivBg':'#8f8f8f',
    'versionNClr':'#999',
    'changlogLblClr':'#b5b5b5',
    'changlogHeadingClr':'#9d9d9d',
    'verHistTxtClr':'#c2c2c2',
    'vrLogDate':'#bdbdbd',
    'accordArrowClr':'#999',
    'tmpNameBg':'#2a2a2a',
    'tmpNameClr':'#ababab',
    'tmpBtnBg':'#0d0d0d',
    'tmpBtnClr':'#c2c2c2',
    //Chart
    'hamburgerIcon':'#a1a1a1',
    'timeheadBg':'#1a1a1a',
    'chartSideMenuBg':'#0a0a0a',
    'chartSideMenuClr':'#f5f5f5', 
    'timeHeadLblClr':'#e2e2e2',
    'timeHeadTextClr':'#c2c2c2',
    'styleGridColor': '#bbb',
    'styleStroke': '#ddd',
    //Report
    'rptTblSpinClr':'#c2c2c2',
    'FltrBarBg':'#35393b',
    'filterBarInnerBg':'#141414',
    'column1LblClr':'#c2c2c2',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#c2c2c2',
    'reportsTblThBrd':'#2c2c30',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#1c1d1e',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'cardHeaderBg':'#b6d7ea',
    'addWidgetHeaderBg':'#313135',
    'addWidgetTitleClr':'#c2c2c2',
    'rptDefaultTabClr':'#999',
    'rtpTabBg':'#262425',
    'ModalBodyBg':'#121212',  
    //Physical Delivery
    'placeRequestBtnBg': '#444444',
    'placeRequestBtnHover': '#333333',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#ffffff',
    'openPosCmdtyRateFont': '#51829A',
    },

    MB:{
    'materialIconsClr':'#b3d0e6',
    'iconDark':'#0b284f',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#d9e7f2',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#0b284f',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#0b284f',
    'uncheckedBg':'#fff',
    'checkedBg':'#004e90',
    'submitBtnBg':'#0d528d',
    'submitBtnClr':'#fff',  
    'submitBtnHvrBg':'#09365d',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#c8e1f1',
    'clearBtnClr':'#132d44',
    'clearBtnHvrBg':'#89bcdc',
    'clearBtnHvrClr':'#143852',
    'tooltipHoverBg':'rgba(20, 71, 140, 0.9)',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#dff1ff',
    'actvOiClr':'#e6f4ff',
    'actvBtnBg':'#9dc0f1',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#14478c',
    'navBarSubClr':'#d3e6ff',
    'repIconBg':"#0d305e url('/images/reports.png')",
    'homeIconBg':"#0d305e url('/images/home.png')",
    'addIconBg':"#0d305e url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#0d305e url('/images/profile.png')",
    'deliveryIconBg':"#0d305e url('/images/delivery.png')",
    'navMenuLabel':'#1d2b58',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#337ab7',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#0d305e',
    'calndrTileEnblHvrBg':'#306fc5',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#306fc5',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#0b284f',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#0b284f',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#3b5f8f',
    'vericalDotIconHoverClr':'#fff',
    'caret':'#dfeef6',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#fff',
    'closeBtnHoverClr':'#0b3e63',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#14478c',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#004e90',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#006dc7',
    //Notifications
    'notfictnVisiblebrdTop':'rgb(60, 138, 195)',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'rgb(60, 138, 195) 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #0661a3',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'rgb(60, 138, 195) 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #0661a3',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'rgb(60, 138, 195) 1px 0px 1px 1px',
    'notfictnDismissClr':'rgb(11, 62, 99)',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#0b284f',
    'defaultTabClr':'#004197',
    'activeTabClr':'#14478c',
    'activeTabBrd':'#14478c',
    'rateDiffBgClr':'#004e90',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#c9dbe8',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#0d528d',
    'sellBuyBtnFontClr':'#fff',
    'caretIconClr':'#0069a1',
    'ordConfirmMsgBg':'#5283ad',
    'ordConfirmMsgClr':'#e8f3fd',
    'closeOrdConfirmMsgIconBg':'#5283ad',
    'noRatesMsgDivBg':'#5283ad',
    'noRatesMsgDivClr':'#e8f3fd',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'trdBookDefaultTabClr':'#a6c6f2',
    'trdBookActTabClr':'#e9f1fc',
    'TrdBookActTbBrd':'#a2c1e9',
    //Profile
    'prfWrpBg':'#0f376d',
    'prfWrpBrd':'#005a8f',
    'userMenuListBg':'#0f376d',
    'userMenuListClr':'#e8eef2',
    'userMenuActvBg':'#2d65b4',
    'userMenuActvClr':'#fff',
    'userMenuHvrBg':'#5581be',
    'hoverDivBg':'#f5f5f5',
    'versionNClr':'#eee',
    'changlogLblClr':'#3178a5',
    'changlogHeadingClr':'#02235d',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#1755a6',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#0D528D',
    'tmpBtnClr':'#fff',
    //Chart
    'hamburgerIcon':'#f9f9f9',
    'timeheadBg':'#0d528d',
    'chartSideMenuBg':'#113f7c',
    'chartSideMenuClr':'#fff',
    'timeHeadLblClr':'#dbe8fa',
    'timeHeadTextClr':'#f9f9f9',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#0a5287',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#14478c',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'cardHeaderBg':'#b6d7ea',
    'addWidgetHeaderBg':'#0b284f',
    'addWidgetTitleClr':'#fff',
    'caretIconClr':'#004e90',
    'headerCaret':"#fff",
    'ModalBodyBg':'#fff',
    'cardHeaderBgClr':'#0d528d',
    'rtpTabBg':'#fff',
    'rptDefaultTabClr':'#14478c',
    //Physical Delivery
    'placeRequestBtnBg': '#0d528d',
    'placeRequestBtnHover': '#09365d',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#0d528d',
    },

    GY:{
    'materialIconsClr':'#5f3a07',
    'iconDark':'#5f3a07',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#5f3a07',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#ffdf00',
    'dropdownMenuHoverTxtClr':'#5f3a07',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#5f3a07',
    'uncheckedBg':'#fff',
    'checkedBg':'#f1a731',
    'submitBtnBg':'#f7d701',
    'submitBtnClr':'#5f3a07',  
    'submitBtnHvrBg':'#dfc30c',
    'submitBtnHvrClr':'#5f3a07',
    'clearBtnBg':'#fff1a8',
    'clearBtnClr':'#5f3a07',
    'clearBtnHvrBg':'#ffe875',
    'clearBtnHvrClr':'5f3a07',
    'tooltipHoverBg':'rgba(242, 212, 13, 0.9)',
    'tooltipHoverClr':'#5f3a07',
    'oi-eyeClr':'#5f3a07',
    'actvOiClr':'#5f3a07',
    'actvBtnBg':'#edaf58',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#f2d40d',
    'navBarSubClr':'#5f3a07',
    'repIconBg':"#FFDF00 url('/images/reports-brown.png')",
    'homeIconBg':"#FFDF00 url('/images/home-brown.png')",
    'addIconBg':"#FFDF00 url('/images/add-brown.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#FFDF00 url('/images/profile-brown.png')",
    'deliveryIconBg':"#FFDF00 url('/images/delivery-brown.png')",
    'navMenuLabel':'#5f3a07',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#5f3a07',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#EBCB00',
    'calndrTileEnblHvrBg':'#FFDF00',
    'calndrTileEnblHvrTxt':'#5f3a07',
    'calndrTilehasActHvrBg':'#ebcb00',
    'calndrTilehasActHvrTxt':'#5f3a07',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#f2d40d',
    'widgetheaderclr':'#2f1d04',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#f2d40d',
    'headerFontClr':'#fff',
    'headerCaret':"#5f3a07",
    'vericalDotIconClr':'#5f3a07',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#ffe5c1',
    'vericalDotIconHoverClr':'#5f3a07',
    'caret':'#5f3a07',
    'closeBtnClr':'#5f3a07',
    'closeBtnBrd':'1px solid #5f3a07',
    'closeBtnHoverBg':'#ffe5c1',
    'closeBtnHoverClr':'#5f3a07',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'rgba(235, 203, 0, .55)',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#e6c700',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#ffdd00',
    //Notifications
    'notfictnVisiblebrdTop':'#e0c306',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#e0c306 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #e0c306',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#e0c306 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #e0c306',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#e0c306 1px 0px 1px 1px',
    'notfictnDismissClr':'#5f3a07',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#5f3a07',
    'valDateClr':'#5f3a07',
    'defaultTabClr':'#5f3a07',
    'activeTabClr':'#5f3a07',
    'activeTabBrd':'#5f3a07',
    'rateDiffBgClr':'#ffdf00',
    'rateDiffFontClr':'#5f3a07',
    'tabContentBg':'#dbdbdb',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#f2d40d',
    'sellBuyBtnFontClr':'#5f3a07',
    'caretIconClr':'#5f3a07',
    'ordConfirmMsgBg':'rgba(244,226,115,0.95)',
    'ordConfirmMsgClr':'#5f3a07',
    'closeOrdConfirmMsgIconBg':'rgba(244,226,115,0.95)',
    'noRatesMsgDivBg':'rgba(244,226,115,0.95)',
    'noRatesMsgDivClr':'#5f3a07',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'cardHeaderBg':'rgba(244,226,115,0.95)',
    'trdBookDefaultTabClr':'#774909',
    'trdBookActTabClr':'#5f3a07',
    'TrdBookActTbBrd':'#5f3a07',
    //Add Widget
    'addWidgetHeaderBg':'#f2d40d',
    'addWidgetTitleClr':'#2f1d04',
    //Profile
    'prfWrpBg':'#ebcb00',
    'prfWrpBrd':'#b99b43',
    'userMenuListBg':'#ebcb00',
    'userMenuListClr':'#5f3a07',
    'userMenuActvBg':'#f5e789',
    'userMenuActvClr':'#5f3a07',
    'userMenuHvrBg':'#f9f0b4',
    'hoverDivBg':'#fffad6',
    'versionNClr':'#5f3a07',
    'changlogLblClr':'#5f3a07',
    'changlogHeadingClr':'#4e4404',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#ffdf00',
    'tmpNameClr':'#5f3a07',
    'tmpBtnBg':'#f2d40d',
    'tmpBtnClr':'#5f3a07',
    //Chart
    'hamburgerIcon':'#5f3a07',
    'timeheadBg':'#f4e273',
    'chartSideMenuBg':'#e9cb0c',
    'chartSideMenuClr':'#392304',
    'timeHeadLblClr':'#ac6400',
    'timeHeadTextClr':'#5f3a07',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#5f3a07',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#5f3a07',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'rptDefaultTabClr':'#7e6701',
    'ModalBodyBg':'#fff',
    'ModalBodyBg':'#fff',
    //Physical Delivery
    'placeRequestBtnBg': '#f7d701',
    'placeRequestBtnHover': '#dfc30c',
    'placeRequestBtnFontClr': '#5f3a07',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#7e6701',
    },

    MY:{
    'materialIconsClr':'#5f3a07',
    'iconDark':'#1c1102',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#1c1102',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#d2810e',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#d2810e',
    'uncheckedBg':'#fff',
    'checkedBg':'#d2810e',
    'submitBtnBg':'#e1890e',
    'submitBtnClr':'#fff',  
    'submitBtnHvrBg':'#bf750d',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#ffd494',
    'clearBtnClr':'#724609',
    'clearBtnHvrBg':'#ffc46b',
    'clearBtnHvrClr':'#724609',
    'tooltipHoverBg':'#D2810E',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#5f3a07',
    'actvOiClr':'#ffc107',
    'actvBtnBg':'#edaf58',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#f1a731',
    'navBarSubClr':'#332600',
    'repIconBg':"#f2930d url('/images/reports.png')",
    'homeIconBg':"#f2930d url('/images/home.png')",
    'addIconBg':"#f2930d url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#f2930d url('/images/profile.png')",
    'deliveryIconBg':"#f2930d url('/images/delivery.png')",
    'navMenuLabel':'#5c4500',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#5c4500',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#F1A731',
    'calndrTileEnblHvrBg':'#ff9800',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#ff9800',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#D2810E',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#D2810E',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#ffe5c1',
    'vericalDotIconHoverClr':'#5c4500',
    'caret':'#f1a731',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#ffe5c1',
    'closeBtnHoverClr':'#d2810e',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#f1a731',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#d2810e',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#f2ae40',
    //Notifications
    'notfictnVisiblebrdTop':'#cd840e',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#cd840e 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #cd840e',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#cd840e 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #cd840e',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#cd840e 1px 0px 1px 1px',
    'notfictnDismissClr':'#5c4500',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#5c4500',
    'defaultTabClr':'#5c4500',
    'activeTabClr':'#9d600b',
    'activeTabBrd':'#e6ac00',
    'rateDiffBgClr':'#D2810E',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#dbdbdb',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#f1a731',
    'sellBuyBtnFontClr':'#fff',
    'caretIconClr':'#d2810e',
    'ordConfirmMsgBg':'rgba(210,129,14,0.95)',
    'ordConfirmMsgClr':'#fff',
    'closeOrdConfirmMsgIconBg':'rgba(210,129,14,0.95)',
    'noRatesMsgDivBg':'rgba(210,129,14,0.95)',
    'noRatesMsgDivClr':'#5c4500',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'cardHeaderBg':'#f1a731',
    'trdBookDefaultTabClr':'#fcebcf',
    'trdBookActTabClr':'#fff',
    'TrdBookActTbBrd':'#fee7c2',
    //Add Widget
    'addWidgetHeaderBg':'#D2810E',
    'addWidgetTitleClr':'#fff',
    //Profile
    'prfWrpBg':'#e59f31',
    'prfWrpBrd':'#ffebb1',
    'userMenuListBg':'#e59f31',
    'userMenuListClr':'#1a1300',
    'userMenuActvBg':'#f4be66',
    'userMenuActvClr':'#241b00',
    'userMenuHvrBg':'#f9f0b4',
    'hoverDivBg':'#fffad6',
    'versionNClr':'#5c4500',
    'changlogLblClr':'#ffc107',
    'changlogHeadingClr':'#4e4404',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#ef9415',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#D2810E',
    'tmpBtnClr':'#fff',
    //Chart
    'hamburgerIcon':'#5c4500',
    'timeheadBg':'#ffc107',
    'chartSideMenuBg':'#ef9415',
    'chartSideMenuClr':'#fff',
    'timeHeadLblClr':'#413100',
    'timeHeadTextClr':'#5c4500',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#D2810E',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#7d651c',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'rptDefaultTabClr':'#7e6701',
    'ModalBodyBg':'#fff',
    'ModalBodyBg':'#fff',
    //Physical Delivery
    'placeRequestBtnBg': '#e1890e',
    'placeRequestBtnHover': '#bf750d',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#D2810E',
    },

    SR:{
    'materialIconsClr':'#f5e9e9',
    'iconDark':'#e10000',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#fff',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#df5349',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#b02626',
    'uncheckedBg':'#fff',
    'checkedBg':'#df5349',
    'submitBtnBg':'#d14747',
    'submitBtnClr':'#fff',  
    'submitBtnHvrBg':'#c43131',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#edc4c5',
    'clearBtnClr':'#813131',
    'clearBtnHvrBg':'#e09a9b',
    'clearBtnHvrClr':'#813131',
    'tooltipHoverBg':'#df5349',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#f8dddd',
    'actvOiClr':'#813131',
    'actvBtnBg':'#ff3c4f',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#CC2C2C',
    'navBarSubClr':'#fff',
    'repIconBg':"#B02626 url('/images/reports.png')",
    'homeIconBg':"#B02626 url('/images/home.png')",
    'addIconBg':"#B02626 url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#B02626 url('/images/profile.png')",
    'deliveryIconBg':"#B02626 url('/images/delivery.png')",
    'navMenuLabel':'#972121',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#972121',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#df5349',
    'calndrTileEnblHvrBg':'#ff6363',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#ff6363',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#B02626',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#B02626',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#ffc3c3',
    'vericalDotIconHoverClr':'#540000',
    'caret':'#540000',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#ffc3c3',
    'closeBtnHoverClr':'#540000',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#CC2C2C',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#c43131',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#d16666',
    //Notifications
    'notfictnVisiblebrdTop':'#c43131',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#c43131 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #c43131',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#c43131 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #c43131',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#c43131 1px 0px 1px 1px',
    'notfictnDismissClr':'#972121',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#972121',
    'defaultTabClr':'#972121',
    'activeTabClr':'#b02626',
    'activeTabBrd':'#dd5151',
    'rateDiffBgClr':'#B02626',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#dbdbdb',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#d14747',
    'sellBuyBtnFontClr':'#fff',
    'caretIconClr':'#b02626',
    'ordConfirmMsgBg':'rgba(224,109,109,0.95)',
    'ordConfirmMsgClr':'#fff',
    'closeOrdConfirmMsgIconBg':'rgba(224,109,109,0.95)',
    'noRatesMsgDivBg':'rgba(224,109,109,0.95)',
    'noRatesMsgDivClr':'#fff',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'cardHeaderBg':'#e06d6d',
    'trdBookDefaultTabClr':'#f5d6d6',
    'trdBookActTabClr':'#fff',
    'TrdBookActTbBrd':'#ff8a8a',
    //Add Widget
    'addWidgetHeaderBg':'#B02626',
    'addWidgetTitleClr':'#fff',
    //Profile
    'prfWrpBg':'#d14747',
    'prfWrpBrd':'#ff8c8c',
    'userMenuListBg':'#d14747',
    'userMenuListClr':'#300000',
    'userMenuActvBg':'#b02626',
    'userMenuActvClr':'#fff0f1',
    'userMenuHvrBg':'#efbebe',
    'hoverDivBg':'#e4cdcd',
    'versionNClr':'#ffe3e3',
    'changlogLblClr':'#972121',
    'changlogHeadingClr':'#d14747',
    'verHistTxtClr':'#560000',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#B02626',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#d14747',
    'tmpBtnClr':'#fff',
    //Chart
    'hamburgerIcon':'#fff',
    'timeheadBg':'#e06d6d',
    'chartSideMenuBg':'#B02626',
    'chartSideMenuClr':'#fff',
    'timeHeadLblClr':'#ffecec',
    'timeHeadTextClr':'#fff',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#B02626',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#952121',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'rptDefaultTabClr':'#952121',
    'ModalBodyBg':'#fff',
    //Physical Delivery
    'placeRequestBtnBg': '#d14747',
    'placeRequestBtnHover': '#c43131',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#d14747',
    },
    
    SG:{
    'materialIconsClr':'#d6fff4',
    'iconDark':'#00563f',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#d6fff4',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#b3d8e9',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#30c57b',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#00563f',
    'uncheckedBg':'#fff',
    'checkedBg':'#00563f',
    'submitBtnBg':'#006a4d',
    'submitBtnClr':'#fff',  
    'submitBtnHvrBg':'#1fad87',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#e7fff9',
    'clearBtnClr':'#095c46',
    'clearBtnHvrBg':'#b8f4e5',
    'clearBtnHvrClr':'#095c46',
    'tooltipHoverBg':'#00563f',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#d6fff4',
    'actvOiClr':'#001a13',
    'actvBtnBg':'#006046',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#004231',
    'navBarSubClr':'#fff',
    'repIconBg':"#00563f url('/images/reports.png')",
    'homeIconBg':"#00563f url('/images/home.png')",
    'addIconBg':"#00563f url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#00563f url('/images/profile.png')",
    'deliveryIconBg':"#00563f url('/images/delivery.png')",
    'navMenuLabel':'#00563f',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#001a13',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#00563f',
    'calndrTileEnblHvrBg':'#008f69',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#00563f',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#00563f',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#fff',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#1fad87',
    'vericalDotIconHoverClr':'#fff',
    'caret':'#00563f',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#1fad87',
    'closeBtnHoverClr':'#fff',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#00916a',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#008f69',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#00c792',
    //Notifications
    'notfictnVisiblebrdTop':'#008a65',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#008a65 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #008a65',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#008a65 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #008a65',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#008a65 1px 0px 1px 1px',
    'notfictnDismissClr':'#008a65',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#00563f',
    'defaultTabClr':'#006D50',
    'activeTabClr':'#00ab3c',
    'activeTabBrd':'#00b887',
    'rateDiffBgClr':'#3d6157',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#dbdbdb',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#006a4d',
    'sellBuyBtnFontClr':'#fff',
    'caretIconClr':'#00563f',
    'ordConfirmMsgBg':'rgba(1,169,123,0.95)',
    'ordConfirmMsgClr':'#aeffe9',
    'closeOrdConfirmMsgIconBg':'rgba(1,169,123,0.95)',
    'noRatesMsgDivBg':'rgba(1,169,123,0.95)',
    'noRatesMsgDivClr':'#aeffe9',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'cardHeaderBg':'#00916A',
    'trdBookDefaultTabClr':'#06d8a1',
    'trdBookActTabClr':'#fff',
    'TrdBookActTbBrd':'#00b887',
    //Add Widget
    'addWidgetHeaderBg':'#00563f',
    'addWidgetTitleClr':'#fff',
    //Profile
    'prfWrpBg':'#00ab7e',
    'prfWrpBrd':'#00ab7e',
    'userMenuListBg':'#00ab7e',
    'userMenuListClr':'#001a13',
    'userMenuActvBg':'#c7f9ec',
    'userMenuActvClr':'#005740',
    'userMenuHvrBg':'#e6f7fe',
    'hoverDivBg':'#a2ead7',
    'versionNClr':'#c8fff0',
    'changlogLblClr':'#001a13',
    'changlogHeadingClr':'#00563f',
    'verHistTxtClr':'#001a13',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#00563f',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#006a4d',
    'tmpBtnClr':'#fff',
    //Chart
    'hamburgerIcon':'#fff',
    'timeheadBg':'#00916a',
    'chartSideMenuBg':'#004231',
    'chartSideMenuClr':'#c0ffee',
    'timeHeadLblClr':'#00f6b4',
    'timeHeadTextClr':'#fff',
    'styleGridColor': '#000000',
    'styleStroke': '#000000',
    //Report
    'rptTblSpinClr':'#001a13',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#001a13',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'rptDefaultTabClr':'#006D50',
    'ModalBodyBg':'#fff',
     //Physical Delivery
    'placeRequestBtnBg': '#006a4d',
    'placeRequestBtnHover': '#034634',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#006a4d',
    },

    TL:{
    'materialIconsClr':'#f5f5f5',
    'iconDark':'#006666',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#f5f5f5',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#007c7c',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#007c7c',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#008585',
    'uncheckedBg':'#fff',
    'checkedBg':'#006666',
    'submitBtnBg':'#007c7c',
    'submitBtnClr':'#fff',  
    'submitBtnHvrBg':'#006666',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#87d3d3',
    'clearBtnClr':'#005252',
    'clearBtnHvrBg':'#72cbcb',
    'clearBtnHvrClr':'#005252',
    'tooltipHoverBg':'#006666',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#f5f5f5',
    'actvOiClr':'#007c7c',
    'actvBtnBg':'#006666',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#333',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#007c7c',
    'navBarSubClr':'#fff',
    'repIconBg':"#008382 url('/images/reports.png')",
    'homeIconBg':"#008382 url('/images/home.png')",
    'addIconBg':"#008382 url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#008382 url('/images/profile.png')",
    'deliveryIconBg':"#008382 url('/images/delivery.png')",
    'navMenuLabel':'#006666',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#006666',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#006666',
    'calndrTileEnblHvrBg':'#008382',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#006666',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#006666',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#006666',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#fff',
    'vericalDotIconHoverClr':'#008382',
    'caret':'#006666',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#fff',
    'closeBtnHoverClr':'#008382',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#006666',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#008382',
    //Notifications
    'notfictnVisiblebrdTop':'#008382',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#008382 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #008382',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#008382 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #008382',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#008382 1px 0px 1px 1px',
    'notfictnDismissClr':'#006666',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#003d3d',
    'defaultTabClr':'#008382',
    'activeTabClr':'#006666',
    'activeTabBrd':'#006666',
    'rateDiffBgClr':'#008382',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#dbdbdb',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#008382',
    'sellBuyBtnFontClr':'#fff',
    'caretIconClr':'#006666',
    'ordConfirmMsgBg':'rgba(0,131,130,0.95)',
    'ordConfirmMsgClr':'#fff',
    'closeOrdConfirmMsgIconBg':'rgba(0,131,130,0.95)',
    'noRatesMsgDivBg':'rgba(0,131,130,0.95)',
    'noRatesMsgDivClr':'#fff',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'cardHeaderBg':'#b6d7ea',
    'trdBookDefaultTabClr':'#87cecf',
    'trdBookActTabClr':'#fff',
    'TrdBookActTbBrd':'#fff',
    'subHeaderBg':'rgba(0,131,130, .85)',
    //Add Widget
    'addWidgetHeaderBg':'#006666',
    'addWidgetTitleClr':'#fff',
    //Profile
    'prfWrpBg':'#008382',
    'prfWrpBrd':'#00c2c2',
    'userMenuListBg':'#008382',
    'userMenuListClr':'#fff',
    'userMenuActvBg':'#005252',
    'userMenuActvClr':'#fff',
    'userMenuHvrBg':'#00a8a8',
    'hoverDivBg':'#c4dfdf',
    'versionNClr':'#faf0ff',
    'changlogLblClr':'#003333',
    'changlogHeadingClr':'#006666',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#008585',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#007c7c',
    'tmpBtnClr':'#fff',
    //Chart
    'hamburgerIcon':'#fff',
    'timeheadBg':'#269595',
    'chartSideMenuBg':'#006666',
    'chartSideMenuClr':'#fff',
    'timeHeadLblClr':'#b4ffff',
    'timeHeadTextClr':'#fff',
    //Report
    'rptTblSpinClr':'#008585',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#008585',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'rptDefaultTabClr':'#008585',
    'ModalBodyBg':'#fff',
    'cardHeaderBgClr':"#b2ddda",
     //Physical Delivery
    'placeRequestBtnBg': '#007c7c',
    'placeRequestBtnHover': '#006666',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#269595',
    },
    
    PL:{
    'materialIconsClr':'#32004b',
    'iconDark':'#32004b',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#32004b',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#4b0070',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#4b0070',
    'dropdownMenuHoverTxtClr':'#fff',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#32004b',
    'uncheckedBg':'#fff',
    'checkedBg':'#4b0070',
    'submitBtnBg':'#4b0070',
    'submitBtnClr':'#fff',  
    'submitBtnHvrBg':'#32004b',
    'submitBtnHvrClr':'#fff',
    'clearBtnBg':'#e4adff',
    'clearBtnClr':'#4b0070',
    'clearBtnHvrBg':'#d484fb',
    'clearBtnHvrClr':'#4b0070',
    'tooltipHoverBg':'rgba(125,63,157, 0.9)',
    'tooltipHoverClr':'#fff',
    'oi-eyeClr':'#32004b',
    'actvOiClr':'rgba(125,63,157, 0.9)',
    'actvBtnBg':'#a35dc7',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#360052',
    'navBarSubClr':'#fff',
    'repIconBg':"#62317a url('/images/reports.png')",
    'homeIconBg':"#62317a url('/images/home.png')",
    'addIconBg':"#62317a url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#62317a url('/images/profile.png')",
    'deliveryIconBg':"#62317a url('/images/delivery.png')",
    'navMenuLabel':'#32004b',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#32004b',
    'calendrBg':'#fff',
    'calendrClr':'#333',
    'calndrTileActBg':'#32004b',
    'calndrTileEnblHvrBg':'#62317a',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#32004b',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#3a0057',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#3a0057',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#fff',
    'vericalDotIconHoverClr':'#62317a',
    'caret':'#32004b',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#fff',
    'closeBtnHoverClr':'#62317a',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#32004b',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#62317a',
    //Notifications
    'notfictnVisiblebrdTop':'#62317a',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#62317a 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #62317a',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#62317a 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #62317a',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#62317a 1px 0px 1px 1px',
    'notfictnDismissClr':'#32004b',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#32004b',
    'defaultTabClr':'#62317a',
    'activeTabClr':'#32004b',
    'activeTabBrd':'#32004b',
    'rateDiffBgClr':'#62317a',
    'rateDiffFontClr':'#fff',
    'tabContentBg':'#dbdbdb',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#62317a',
    'sellBuyBtnFontClr':'#f7eafb',
    'caretIconClr':'#62317a',
    'ordConfirmMsgBg':'rgba(125,63,157,0.95)',
    'ordConfirmMsgClr':'#fff',
    'closeOrdConfirmMsgIconBg':'rgba(125,63,157,0.95)',
    'noRatesMsgDivBg':'rgba(125,63,157,0.95)',
    'noRatesMsgDivClr':'#fff',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'cardHeaderBg':'#b6d7ea',
    'trdBookDefaultTabClr':'#c4a7d2',
    'trdBookActTabClr':'#dedede',
    'TrdBookActTbBrd':'#dec0ed',
    'subHeaderBg':'rgba(125,63,157, .55)',
    //Add Widget
    'addWidgetHeaderBg':'#3a0057',
    'addWidgetTitleClr':'#fff',
    //Profile
    'prfWrpBg':'#440066',
    'prfWrpBrd':'#da90ff',
    'userMenuListBg':'#440066',
    'userMenuListClr':'#ebc2ff',
    'userMenuActvBg':'#892fb5',
    'userMenuActvClr':'#faf0ff',
    'userMenuHvrBg':'#ad5dd5',
    'hoverDivBg':'#f6e5ff',
    'versionNClr':'#faf0ff',
    'changlogLblClr':'#440066',
    'changlogHeadingClr':'#843fa6',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#62317a',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#32004b',
    'tmpBtnClr':'#fff',
    //Chart
    'hamburgerIcon':'#fff',
    'timeheadBg':'#892fb5',
    'chartSideMenuBg':'#440066',
    'chartSideMenuClr':'#fff',
    'timeHeadLblClr':'#efcfff',
    'timeHeadTextClr':'#e7b6ff',
    "styleGridColor": '#000000',
    "styleStroke": '#000000',
    //Report
    'rptTblSpinClr':'#440066',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#440066',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'rptDefaultTabClr':'#62317a',
    'ModalBodyBg':'#fff',
    'ModalBodyBg':'#fff',
    //Physical Delivery
    'placeRequestBtnBg': '#4b0070',
    'placeRequestBtnHover': '#32004b',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#892FB5',
    },

    IG:{
    'materialIconsClr':'#333',
    'iconDark':'#333',
    'text-mutedClr':'#6c757d',
    'noDataColorBg':'#f5f5f5',
    'mdlWrapBg':'#fff',
    'tabHeaderClr':'#fff',
    'countColor':'#000',
    'errorTxtClr':'#b00020',
    //Form Elements
    'inputBg':'#fff',
    'inputClr':'#333',
    'inputBorder':'#c5c6c8',
    'inputHvrFcsBorder':'#3A3A3A',
    'disableInputBg':'#e9ecef',
    'disableInputClr':'#6c757d',
    'dropDownHoverBg':'#545454',
    'dropdownMenuHoverTxtClr':'#f6f6f7',
    'dropdownMenuBgClr':'#fff',
    'dropdownMenuFontClr':'#121b21',
    'uncheckedBg':'#fff',
    'checkedBg':'#333',
    'submitBtnBg':'#3A3A3A',
    'submitBtnClr':'#f9f9f9',
    'submitBtnHvrBg':'#2e2e2e',
    'submitBtnHvrClr':'#f9f9f9',
    'clearBtnBg':'#ccc',
    'clearBtnClr':'#333',
    'clearBtnHvrBg':'#b3b3b3',
    'clearBtnHvrClr':'#333',
    'tooltipHoverBg':'#3a3a3a',
    'tooltipHoverClr':'#f9f9f9',
    'oi-eyeClr':'#3a3a3a',
    'actvOiClr':'#efefef',
    'actvBtnBg':'#838383',
    //Table
    'tblBg':'#fff',
    'tblClr':'#333',
    'thBg':'#fff',
    'thClr':'#333',
    'tdBorder':'#ddd',
    'listRowOddBg':'#f5f5f5',
    'listRowClr':'#000',
    'listRowBrdClr':'#ddd',
    'listRowNextBg':'#fff',
    'listRowNextClr':'#000',
    'listRowNextBrd':'#ddd',
    'pagingPnlClr':'#333',
    'tableBodyTxtClr':'#333',
    // 'dx_g_bs4_table_cellClr':'#fff',
    'dx_g_bs4_table_cellBrd':'#ddd',    
    //Navbar    
    'navBarBg':'#fff',
    'navBarSubBg':'#404042',
    'navBarSubClr':'#e5e5e5',
    'repIconBg':"#474748 url('/images/reports.png')",
    'homeIconBg':"#474748 url('/images/home.png')",
    'addIconBg':"#474748 url('/images/add.png')",
    'addDisabledBg':"#ddd url('/images/add-grey.png')",
    'prflIconBg':"#474748 url('/images/profile.png')",
    'deliveryIconBg':"#474748 url('/images/delivery.png')",
    'navMenuLabel':'#474748',    
    'responsiveReactGridLayoutBg':'#e2e3e5',
    'react-grid-itemBg':'#fff',
    //Calendar
    'calendrHeading':'#4d4d4d',
    'calendrBg':'#fff',
    'calendrClr':'#333',    
    'calndrTileActBg':'#4d4d4d',
    'calndrTileEnblHvrBg':'#737373',
    'calndrTileEnblHvrTxt':'#fff',
    'calndrTilehasActHvrBg':'#404040',
    'calndrTilehasActHvrTxt':'#fff',
    'calndrDtDisbld':'#ddd',
    'calendrIcon':"url('/images/calender.png')",
    'collectionDateCalendrIcon':"url('/images/collection-date-icon.png')",
    //Widget
    'widgetheaderBg':'#474748',
    'widgetheaderclr':'#fff',
    'widgetBdyBg':'#fff',
    'widgetlabel':'#333',
    'headerBgClr':'#474748',
    'headerFontClr':'#fff',
    'headerCaret':"#fff",
    'vericalDotIconClr':'#fff',
    'vericalDotIconBg':'none',
    'vericalDotIconHoverBg':'#fff',
    'vericalDotIconHoverClr':'#12202b',
    'caret':'#474748',
    'closeBtnClr':'#fff',
    'closeBtnBrd':'1px solid #fff',
    'closeBtnHoverBg':'#f5f5f5',
    'closeBtnHoverClr':'#181818',
    'widgetwrapperBg':'#fff',
    'widgetwrapperBrd':'#fff',
    'subHeaderBg':'#ABABAB',
    //ResizeGrid
    'resizeLyoutBg':'#fff',
    'resizeGridSelectBg':'#3a3a3a',
    'resizeGridSelectBrd':'#ccc',
    'resizeGridBoxHvrBg':'#6b6b6b',
    //Notifications
    'notfictnVisiblebrdTop':'#333',
    'notfictnVisibleBg':'#fff',
    'notfictnVisibleClr':'rgb(0, 0, 0)',
    'notfictnVisibleBoxShdw':'#2c2c2c 1px 0px 1px 1px',
    'notfictnSuccessBrdTop':'4px solid #333',
    'notfictnSuccessBg':'rgb(255, 255, 255)',
    'notfictnSuccessClr':'#000',
    'notfictnSuccessBox-shadow':'#333 1px 0px 1px 1px',
    'notificationBrdTop':'4px solid #2c2c2c',
    'notificationBg':'rgb(255, 255, 255)',
    'notfictnClr':'#000',
    'notfictnBox-shadow':'#2c2c2c 1px 0px 1px 1px',
    'notfictnDismissClr':'#333',
    'notfictnDismissBg':'#fff',
    'notifyMsgClr':'rgb(78, 76, 76)',
    //Trading Widget   
    'trdHeadBg':'#fff',
    'WidgetCmdtytitleClr':'#fff',
    'valDateClr':'#626c72',
    'defaultTabClr':'#2c2c2c',
    'activeTabClr':'#4d4d4d',
    'activeTabBrd':'#707070',
    'rateDiffBgClr':'#c2c7cc',
    'rateDiffFontClr':'#060606',
    'tabContentBg':'#a5acb4',
    'ratesBg':'#fff',
    'sellBuyBtnBgClr':'#3A3A3A',
    'sellBuyBtnFontClr':'#f9f9f9',
    'caretIconClr':'#474748',
    'ordConfirmMsgBg':'rgba(104,104,104,0.95',
    'ordConfirmMsgClr':'#dadada',
    'closeOrdConfirmMsgIconBg':'#dadada',
    'noRatesMsgDivBg':'rgba(104,104,104,0.95)',
    'noRatesMsgDivClr':'#dadada',
    'pfoLblBg':'#fff',
    'pfoLblClr':'#333',
    //Trade Book
    'trdBookDefaultTabClr':'#bbb',
    'trdBookActTabClr':'#fff',
    'TrdBookActTbBrd':'#ccc',
    //Profile
    'prfWrpBg':'#fafafa',
    'prfWrpBrd':'#b1b1b1',
    'userMenuListBg':'#fafafa',
    'userMenuListClr':'#333',
    'userMenuActvBg':'#ebebeb',
    'userMenuActvClr':'#333',
    'userMenuHvrBg':'#d9d9d9',
    'hoverDivBg':'#c2c7cc',
    'versionNClr':'#5c666d',
    'changlogLblClr':'#141415',
    'changlogHeadingClr':'#474748',
    'verHistTxtClr':'#333',
    'vrLogDate':'#666',
    'accordArrowClr':'#999',
    'tmpNameBg':'#474748',
    'tmpNameClr':'#fff',
    'tmpBtnBg':'#e7e7e8',
    'tmpBtnClr':'#333',
    //Chart
    'hamburgerIcon':'#333',
    'timeheadBg':'#ABABAB',
    'chartSideMenuBg':'#474748',
    'chartSideMenuClr':'#4c4c4c',
    'timeHeadLblClr':'#000',
    'timeHeadTextClr':'#121212',
    "styleGridColor": '#000000',
    "styleStroke": '#000000',
    //Report
    'rptTblSpinClr':'#4d4d4d',
    'FltrBarBg':'#e3e5e6',
    'filterBarInnerBg':'#fff',
    'column1LblClr':'#333',
    'reportsTblThBg':'none',
    'reportsTblThClr':'#4d4d4d',
    'reportsTblThBrd':'#ddd',
    'reportsTblGridBg':'#fff',
    'reportsTblGridClr':'#000',
    'statOfAccTrdAnlRptBg':'#fff',
    'rptLoaderBg':'rgba(0, 0, 0, 0.4)',
    'cardHeaderBg':'#b6d7ea',
    'addWidgetHeaderBg':'#474748',
    'addWidgetTitleClr':'#fff',
    'rptDefaultTabClr':'#2c2c2c',
    'rtpTabBg':'#fff',
    'ModalBodyBg':'#fff',
    'cardHeaderBgClr':'#ababab',
    //Physical Delivery
    'placeRequestBtnBg': '#3a3a3a',
    'placeRequestBtnHover': '#2e2e2e',
    'placeRequestBtnFontClr': '#FFF',
    'placeReqOpenPosLab': '#000000',
    'openPosCmdtyRateFont': '#474748',
    },

    GD:{
        'sellBuyBtnBgClr':'#ffbf00',
        'sellBuyBtnFontClr':'#000',
        'cardHeaderBgClr':"#ffefbf",
        'styleGridColor': '#000000',
        'styleStroke': '#000000',
    }
}